import { render, staticRenderFns } from "./issueRiskActionPlanAppr.vue?vue&type=template&id=24441e68"
import script from "./issueRiskActionPlanAppr.vue?vue&type=script&lang=js"
export * from "./issueRiskActionPlanAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24441e68')) {
      api.createRecord('24441e68', component.options)
    } else {
      api.reload('24441e68', component.options)
    }
    module.hot.accept("./issueRiskActionPlanAppr.vue?vue&type=template&id=24441e68", function () {
      api.rerender('24441e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/iei/issueRiskActionPlanAppr.vue"
export default component.exports